import React, { Suspense, lazy } from "react"
import Spinner from './components/spinner'
import {BrowserRouter as Router} from 'react-router-dom'


const Home = lazy(() => import("./Home"))

function App() {

  return (
    <Suspense fallback={<Spinner />}>
      <Router>
        <Home />

      </Router>
  </Suspense>
   
  );
}

export default App;



